import { Link } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useAppSelector } from '../../../../store'
import { selectRestaurantDetail } from '../../../../store/restaurantSlice'
import { logEvent } from '../../../../analytics/analytics'
import {
  AboutTabContactInfoMuiContainer,
  AboutTabContactInfoTypography,
  AboutTabRestaurantTypography,
} from '../styled/AboutTab.styled'

const AboutTab: React.FC = () => {
  const restaurant = useAppSelector(selectRestaurantDetail)?.restaurantDTO

  const [website, setWebsite] = useState('')

  const contactInfo = [
    restaurant?.phone && {
      label: 'Phone Number',
      value: restaurant.phone,
    },
    restaurant?.contactEmail && {
      label: 'Email',
      value: `mailto:${restaurant.contactEmail}`,
    },
    restaurant?.website && {
      label: 'Website',
      value: website,
    },
    restaurant?.instagram && {
      label: 'Instagram',
      value: restaurant.instagram,
    },
    restaurant?.facebook && {
      label: 'Facebook',
      value: restaurant.facebook,
    },
  ].filter(Boolean) as Array<{ label: string; value: string; target?: string }>

  useEffect(() => {
    setWebsite(normalizeUrl(restaurant?.website ?? ''))
  }, [])

  // Outbound-intent signals from the About tab: a tap on the website link (website_click) or a
  // social / contact link (social_link_click) is a strong "I'm seriously considering this place" cue.
  const trackContactClick = (label: string): void => {
    const restaurantId = restaurant?.restaurantId ?? ''
    if (label === 'Website') {
      let host: string | undefined
      try {
        host = restaurant?.website ? new URL(website).host : undefined
      } catch {
        host = undefined
      }
      logEvent('website_click', {
        restaurant_id: restaurantId,
        restaurant_alias: restaurant?.alias ?? undefined,
        destination_host: host,
        screen_name: 'restaurant_detail',
      })
    } else if (label === 'Instagram' || label === 'Facebook' || label === 'Email') {
      logEvent('social_link_click', {
        restaurant_id: restaurantId,
        channel: label.toLowerCase(),
        screen_name: 'restaurant_detail',
      })
    }
  }

  const normalizeUrl = (url: string): string => {
    let normalized = url.replace(/^https?:\/\//, '').replace(/\/.*$/, '')
    if (!normalized.startsWith('www.')) {
      normalized = 'www.' + normalized
    }
    normalized = 'http://' + normalized

    return normalized
  }

  return (
    <div>
      {restaurant?.description && (
        <AboutTabRestaurantTypography>
          {restaurant.description}
        </AboutTabRestaurantTypography>
      )}
      <AboutTabContactInfoMuiContainer>
        {contactInfo.map((info, index) => (
          <div key={index}>
            <AboutTabContactInfoTypography>
              {info?.label}
            </AboutTabContactInfoTypography>
            {info?.label !== 'Phone Number' ? (
              <Link
                variant="body2"
                href={info?.value?.replace(/^(tel:|mailto:)/, '')}
                fontWeight={500}
                color="primary"
                underline="hover"
                target="_blank"
                onClick={() => trackContactClick(info.label)}
                sx={{
                  cursor: 'pointer',
                }}
              >
                {info?.value?.replace(/^(tel:|mailto:)/, '')}
              </Link>
            ) : (
              <Link
                variant="body2"
                href={`tel:${info?.value}`}
                fontWeight={500}
                color="primary"
                underline="hover"
                target="_self"
                sx={{
                  cursor: 'pointer',
                }}
              >
                {info?.value}
              </Link>
            )}
          </div>
        ))}
      </AboutTabContactInfoMuiContainer>
    </div>
  )
}

export default AboutTab
